<script setup lang="ts">
import { ref } from 'vue';

import SmallBtn from '@/components/btns/SmallBtn.vue';
import KParentTooltip from '@/components/tooltips/KParentTooltip.vue';
import useField from '@/composables/useField';

export type ModelValue = 0 | 1;
export type Values = [string, string];

export interface Props {
  modelValue?: ModelValue;
  disabled?: boolean;
  values?: Values;
}
const props = withDefaults(defineProps<Props>(), {
  modelValue: 0,
  disabled: false,
  values: () => ['AEDT', 'ACT'],
});
const emit = defineEmits<{
  'update:modelValue': [value: (typeof props)['modelValue']];
}>();

const fieldValue = ref(props.modelValue);

useField(props, fieldValue, (newFieldValue) => {
  emit('update:modelValue', newFieldValue as (typeof props)['modelValue']);
});

function handleClick(): void {
  if (fieldValue.value === 0) {
    fieldValue.value = 1;
    // TODO
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  } else if (fieldValue.value === 1) {
    fieldValue.value = 0;
  } else {
    fieldValue.value = 0;
  }
}
</script>

<template>
  <SmallBtn
    :disabled="props.disabled"
    data-testid="smallBtnSwitchField"
    @click="handleClick"
  >
    <KParentTooltip v-if="!props.disabled">
      Switch to
      <template v-if="fieldValue === 0">{{ props.values[1] }}</template>
      <template v-else-if="fieldValue === 1">{{ props.values[0] }}</template>
      <template v-else>{{ props.values[0] }}</template>
    </KParentTooltip>
    {{ props.values[fieldValue] ?? props.values[0] }}
  </SmallBtn>
</template>
